var _rect, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaneDeparture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#E6E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.208,
    y: 53.6746,
    width: 44.2998,
    height: 1.84348,
    rx: 0.921741,
    fill: "#8E8CEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5811,
    y: 47.007,
    width: 11.2465,
    height: 1.84348,
    rx: 0.921741,
    transform: "rotate(-19.8838 18.5811 47.007)",
    fill: "#8E8CEE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 43.4581,
    width: 11.2465,
    height: 1.84348,
    rx: 0.921741,
    transform: "rotate(-19.8838 16 43.4581)",
    fill: "#8E8CEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4666 32.5618L27.5713 33.8221L34.3313 42.3583L43.6695 39.3792L42.6383 46.3113L46.4767 45.7957L52.3776 36.572L59.2523 33.8221L62.8043 31.3587L63.0908 29.0671L61.6012 27.1192L58.6222 26.489L36.9093 34.9679L31.4666 32.5618Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5453 27.684C60.1974 27.0838 61.6889 28.033 62.0212 29.2733C62.1644 29.8076 62.0365 30.3162 61.6037 30.8642C61.1739 31.4083 60.479 31.9339 59.6108 32.4056L52.7963 35.1739C52.2116 35.4115 51.7167 35.8273 51.3821 36.3624L46.1286 44.7608C45.9921 44.979 45.7767 45.1362 45.5272 45.1997L43.4361 45.7313L44.8465 39.1617L45.2238 37.4041L43.5315 38.0104L34.7216 41.1665C34.318 41.311 33.8672 41.1823 33.6008 40.8464L28.4653 34.3713L30.8491 33.5639C31.1416 33.4648 31.4635 33.5064 31.7211 33.6767L34.2637 35.3567C35.0614 35.8838 36.0626 35.9991 36.9592 35.6671L49.2057 31.1328L58.5423 27.6758L58.5453 27.684ZM57.876 25.7992C60.5924 24.8209 63.309 26.3522 63.9531 28.7556C64.2986 30.0452 63.8939 31.1913 63.1731 32.1039C62.4735 32.9895 61.4487 33.7014 60.3904 34.2565L60.3866 34.2492L53.5491 37.0269C53.3542 37.1061 53.1892 37.2447 53.0776 37.423L47.8242 45.8215C47.4146 46.4762 46.7684 46.9477 46.02 47.138L43.9289 47.6696C42.4907 48.0353 41.1692 46.7624 41.4807 45.3115L42.5137 40.4994L35.3961 43.0493C34.1854 43.483 32.833 43.0968 32.0338 42.0892L26.8983 35.6141C26.0384 34.5298 26.513 32.9209 27.8237 32.477L30.2074 31.6696C31.085 31.3724 32.0507 31.4973 32.8237 32.0081L35.3663 33.6881C35.6322 33.8638 35.9659 33.9022 36.2648 33.7915L48.5113 29.2572L57.873 25.791L57.876 25.7992Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneDeparture);
export default __webpack_public_path__ + "static/media/plane-departure.2ea4828dc0598d85ed0ebe5b1ebc2301.svg";
export { ForwardRef as ReactComponent };